<template>
  <div
    class="font-sans"
    :style="{
      backgroundColor: `#${secondaryColor}`,
    }"
  >
    <div class="flex justify-center relative">
      <div
        class="absolute right-0 h-[13rem] w-full rounded-b-3xl"
        :style="{
          'background-color': `#${primaryColor}`,
        }"
      />

      <div class="pb-16 z-1 w-full">
        <div class="w-full pb-4 pt-12 px-2">
          <div class="text-white text-center text-3xl sm:text-4xl pb-4 font-bold">
            {{ __('co_reg_lander_002_prospects_text') }}
          </div>
        </div>

        <div class="flex justify-center px-8">
          <div
            v-if="!success"
            class="w-full bg-white rounded-3xl shadow-xl h-full"
          >
            <div class="pt-8 px-8 grid space-y-8 flex justify-center">
              {{ __('co_reg_lander_002_prospects_form_text') }}
            </div>

            <div class="p-8 grid space-y-8 flex justify-center">
              <div class="grid gap-y-6">
                <div class="pb-2">
                  <p class="font-bold text-xl pb-4 text-center">
                    {{ __('label_email') }}
                  </p>

                  <input
                    v-model="email"
                    name="email"
                    class="w-full h-12 border border-gray-300 rounded-md"
                    type="email"
                    @keydown.enter="submit()"
                  >

                  <ErrorMessage name="email" />
                </div>

                <FormFooter
                  :button-color="buttonColor"
                  :can-submit="!!email && !loading"
                  step="prospects"
                  @submit="submit()"
                />
              </div>
            </div>
          </div>
          <div
            v-else
            class="w-full bg-white rounded-3xl shadow-xl h-full"
          >
            <div class="py-16 px-8 grid space-y-8 flex justify-center">
              <p class="text-center text-xl font-semibold">
                {{ __('co_reg_lander_002_prospects_success_text') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, nextTick, onMounted, ref} from 'vue';
import ErrorMessage from '@timon/js/Components/ErrorMessage.vue';
import FormFooter from '@timon/js/Templates/CO-REG-LANDER-002/Components/FormFooter.vue';
import axios from 'axios';
import {useStore} from 'vuex';

const store = useStore();
const props = defineProps({
  countryCode: {
    type: String,
    required: true,
  },

  languageCode: {
    type: String,
    required: true,
  },

  iframeDomain: {
    type: String,
    required: true,
  },

  adUrlSourceExternalId: {
    type: Number,
    required: true,
  },

  adUrlTypeExternalId: {
    type: Number,
    required: true,
  },
});

const primaryColor = ref('76cac3');
const secondaryColor = ref('e2f5f2');
const buttonColor = ref('ffa039');

const email = ref('');
const loading = ref(false);
const success = ref(false);

onMounted(() => {
  resize();
});

const resize = () => {
  if (window && window.parent) {
    const message = {
      type: 'resize',
      height: document.body.scrollHeight,
    };
    window.parent.postMessage(
      message,
      props.iframeDomain,
    );
  }
};

const submit = () => {
  if (loading.value) {
    return;
  }

  loading.value = true;

  if (!email.value) {
    loading.value = false;

    return;
  }

  axios.post(route('zazu.v1.prospects.store'), {
    country_code: props.countryCode,
    language_code: props.languageCode,
    ad_url_source_external_id: props.adUrlSourceExternalId,
    ad_url_type_external_id: props.adUrlTypeExternalId,
    email: email.value,
  })
    .then(() => {
      loading.value = false;
      success.value = true;

      nextTick(() => {
        resize();
      });
    })
    .catch((error) => {
      if (error.response.data.errors) {
        store.commit('errors/setErrors', error.response.data.errors);
      }

      loading.value = false;
    });
};
</script>
